import { Routes } from '@angular/router';
import { AccountDetailsComponent } from './containers/account-details/account-details.component';
import { AccountUserComponent } from './containers/account-user/account-user.component';
import { AccountListComponent } from './containers/account-list/account-list.component';

export const ACCOUNT_ROUTES: Routes = [
  {
    path: 'accounts',
    component: AccountListComponent,
    data: { title: 'Accounts | One Back Office' },
  },
  {
    path: 'accounts/:id',
    component: AccountDetailsComponent,
  },
  {
    path: 'accounts/:accountId/users/:userId',
    component: AccountUserComponent,
  },
];
